/* Verktygsplatsen — Gro Finans (företagsleasing / betala per månad).
   Talks ONLY to our Cloudflare proxy (window.GRO_CONFIG.proxyUrl); the proxy holds
   the secret x-api-key. All amounts sent are EX VAT (kronor) — Liquid converts the
   VAT-inclusive shop prices (× 0.8) before they reach this script.

   Hooks:
     [data-gro-pdp][data-gro-price=<ex-vat-kr>]            → "Företagsleasing från X kr/mån"
     [data-gro-checkout][data-gro-total=<ex-vat-kr>]       → month options + apply (createcase)
       (reads contact form #vpfk-form fields + <script data-gro-products> JSON) */
(function () {
  var CFG = window.GRO_CONFIG || {};
  var PROXY = (CFG.proxyUrl || "").replace(/\/+$/, "");
  if (!PROXY) return;

  function kr(n) {
    return Math.round(Number(n) || 0).toLocaleString("sv-SE").replace(/[\u00a0\u202f]/g, " ") + " kr";
  }
  function calculate(basePrice) {
    return fetch(PROXY + "/calculate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ basePrice: Math.round(basePrice) }),
    }).then(function (r) { return r.json(); });
  }
  function createCase(payload) {
    return fetch(PROXY + "/createcase", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ payload: payload }),
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); });
  }
  function lowest(opts) {
    return opts.reduce(function (a, b) { return b.monthlyPayment < a.monthlyPayment ? b : a; });
  }

  /* Clicking the PDP leasing teaser behaves like the theme's "Faktura / offert"
     button: add the currently selected variant to the cart, then send the shopper
     to the faktura/leasing checkout (where they pick a term + apply). Mirrors the
     pay_with_invoice block in snippets/product-form.liquid. */
  function goToInvoice() {
    var url = CFG.invoiceUrl || "/pages/faktura";
    var form = document.querySelector('form[action*="/cart/add"]');
    var idEl = form && form.elements ? form.elements["id"] : null;
    var variantId = idEl ? idEl.value : "";
    var qtyEl = form && form.elements ? form.elements["quantity"] : null;
    var qty = qtyEl && qtyEl.value ? parseInt(qtyEl.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    if (!variantId) { window.location.href = url; return; }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    }).then(function () { window.location.href = url; })
      .catch(function () { window.location.href = url; });
  }

  /* ---------------- PDP: "från X kr/mån" (klickbar → faktura/leasing) ---------------- */
  function initPdp(el) {
    if (el.__gro) return;
    var base = parseFloat(el.getAttribute("data-gro-price"));
    if (!isFinite(base) || base <= 0) return;
    el.__gro = true;
    el.addEventListener("click", function () { goToInvoice(); });
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); goToInvoice(); }
    });
    calculate(base).then(function (d) {
      if (!d || !Array.isArray(d.paymentOptions) || !d.paymentOptions.length) { el.hidden = true; return; }
      var lo = lowest(d.paymentOptions);
      el.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>' +
        '<span>Företagsleasing från <b>' + kr(lo.monthlyPayment) + "/mån</b> <i>· " + lo.months + " mån, exkl. moms</i></span>" +
        '<svg class="gro-pdp__go" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      el.hidden = false;
      el.setAttribute("role", "link");
      el.setAttribute("tabindex", "0");
      el.title = "Ansök om företagsleasing – betala per månad";
    }).catch(function () { el.hidden = true; });
  }

  /* ---------------- Faktura checkout: options + apply ---------------- */
  function initCheckout(el) {
    if (el.__gro) return;
    var total = parseFloat(el.getAttribute("data-gro-total"));
    if (!isFinite(total) || total <= 0) { el.hidden = true; return; }
    el.__gro = true;
    var body = el.querySelector("[data-gro-body]");

    calculate(total).then(function (d) {
      if (!d || !Array.isArray(d.paymentOptions) || !d.paymentOptions.length) { el.hidden = true; return; }
      var opts = d.paymentOptions.slice().sort(function (a, b) { return a.months - b.months; });
      var html = '<div class="gro-opts">';
      opts.forEach(function (o, i) {
        html +=
          '<label class="gro-opt"><input type="radio" name="gro-term" value="' + o.months +
          '" data-monthly="' + o.monthlyPayment + '"' + (i === opts.length - 1 ? " checked" : "") +
          '><span class="radio"></span><span class="gro-opt__t"><b>' + kr(o.monthlyPayment) + "/mån</b><span>" +
          o.months + " mån</span></span></label>";
      });
      html += "</div>";
      html += '<button type="button" class="gro-apply" data-gro-apply>Ansök om månadsbetalning</button>';
      html += '<p class="gro-note">Restvärde 10 %, 0 % kontantinsats, exkl. moms. Gro Finans gör en kreditprövning på organisationsnumret.</p>';
      html += '<div class="gro-result" data-gro-result hidden></div>';
      body.innerHTML = html;
      el.hidden = false;
    }).catch(function () { el.hidden = true; });

    el.addEventListener("click", function (e) {
      var b = e.target.closest("[data-gro-apply]");
      if (b) { e.preventDefault(); applyCheckout(el, b); }
    });
  }

  /* Record an approved leasing application as a draft order in Shopify, so it turns up
     next to the invoice and quote requests instead of living only in an e-mail. */
  function registerDraft(el, p, caseNo) {
    if (!PROXY) return;
    var form = document.getElementById("vpfk-form");
    var g = function (n) {
      var x = form && form.querySelector('[name="contact[' + n + ']"]');
      return x ? (x.value || "").trim() : "";
    };
    var items = [];
    try {
      var node = document.querySelector("[data-fk-order]");
      if (node) items = (JSON.parse(node.textContent || "{}") || {}).items || [];
    } catch (e) {}

    var sid;
    try {
      sid = sessionStorage.getItem("vpfk_sid");
      if (!sid) { sid = "w" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }
      sessionStorage.removeItem("vpfk_sid"); // an approved application ends this submission
    } catch (e) { sid = "w" + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); }

    var note = [
      "── FINANSIERING VIA GRO ────────",
      "Gro ärendenummer: " + (caseNo || "–"),
      Math.round(Number(p.monthlyPayment)) + " kr/mån i " + p.months + " mån (exkl. moms)",
      "Totalbelopp: " + Math.round(Number(p.totalAmount)) + " kr exkl. moms",
      "",
      "── FÖRETAG ─────────────────────",
      p.companyName || "",
      "Org.nr: " + p.customerCompanyId,
      "",
      "Gro Finans sköter kreditprövning och fakturering. Ingen faktura från oss."
    ].filter(Boolean).join("\n");

    fetch(PROXY + "/draftorder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        flow: "leasing",
        submissionId: sid,
        customer: {
          name: p.customerContactName,
          email: p.customerContactEmail,
          phone: p.customerContactPhone,
          company: p.companyName,
          orgnr: p.customerCompanyId
        },
        billing: { address1: g("Fakturaadress"), zip: g("Postnummer"), city: g("Ort") },
        items: items,
        shippingSek: 0,
        groCase: caseNo ? String(caseNo) : "",
        note: note
      })
    }).catch(function () {});
  }

  function applyCheckout(el, btn) {
    var form = document.getElementById("vpfk-form");
    var get = function (n) {
      var x = form && form.querySelector('[name="contact[' + n + ']"]');
      return x ? (x.value || "").trim() : "";
    };
    var result = el.querySelector("[data-gro-result]");
    var fail = function (msg) {
      if (result) { result.hidden = false; result.className = "gro-result gro-result--err"; result.textContent = msg; }
    };

    var orgnr = get("Orgnr"), name = get("name"), email = get("email"), phone = get("Telefon"), foretag = get("Foretag");
    if (!orgnr || !name || !email || !phone) {
      fail("Fyll i kontaktperson, telefon, e-post och organisationsnummer i formuläret ovan först.");
      if (form) form.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    var sel = el.querySelector('[name="gro-term"]:checked');
    if (!sel) { fail("Välj en betalningsperiod."); return; }

    var total = parseFloat(el.getAttribute("data-gro-total"));
    var products = [];
    try {
      var node = document.querySelector("[data-gro-products]");
      if (node) products = JSON.parse(node.textContent || "[]");
    } catch (e) {}
    if (!products.length) products = [{ name: foretag || "Order", qty: "1", price: Math.round(total) }];

    btn.disabled = true;
    btn.textContent = "Skickar ansökan…";
    var payload = {
      totalAmount: Math.round(total),
      customerCompanyId: orgnr.replace(/\D/g, ""),
      companyName: foretag,
      customerContactName: name,
      customerContactPhone: phone,
      customerContactEmail: email,
      monthlyPayment: Number(sel.getAttribute("data-monthly")),
      months: parseInt(sel.value, 10),
      products: products,
    };
    // The Cloudflare worker creates the Gro case AND e-mails Verktygsplatsen (via Resend)
    // in the same server-side step — no Shopify form, so no captcha, and we stay on the page.
    createCase(payload).then(function (res) {
      if (res.ok && res.data && res.data.success) {
        /* This flow never posts the Shopify contact form — it stays on the page — so the
           draft order is registered here instead, tagged with the Gro case number. Fire
           and forget: a failed draft must not spoil an approved application. */
        registerDraft(el, payload, res.data.caseNumber);
        var bodyEl = el.querySelector("[data-gro-body]");
        bodyEl.innerHTML =
          '<div class="gro-done"><div class="gro-done__mark"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg></div>' +
          "<h4>Ansökan inskickad!</h4><p>Ärendenummer <b>" + (res.data.caseNumber || "–") +
          "</b>. Gro Finans hör av sig om kreditprövning och nästa steg.</p></div>";
      } else {
        btn.disabled = false;
        btn.textContent = "Ansök om månadsbetalning";
        fail((res.data && res.data.error) || "Något gick fel — försök igen.");
      }
    }).catch(function () {
      btn.disabled = false;
      btn.textContent = "Ansök om månadsbetalning";
      fail("Kunde inte skicka ansökan — försök igen.");
    });
  }

  /* ---------------- boot + re-scan on PDP variant re-render ---------------- */
  function scan() {
    document.querySelectorAll("[data-gro-pdp]").forEach(initPdp);
    document.querySelectorAll("[data-gro-checkout]").forEach(initCheckout);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
  else scan();

  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 250); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
